<template>
    <div>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.663302394219!2d-51.02706358488557!3d-30.01782288189207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95199fe5a00b5ed3%3A0x1e5633bb3a0f802d!2sR.%20Pedro%20Machado%20de%20Oliveira%20-%20Vila%20Elsa%2C%20Viam%C3%A3o%20-%20RS!5e0!3m2!1spt-BR!2sbr!4v1583262108993!5m2!1spt-BR!2sbr"  width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>